import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Header/MobileMenu.js",
  _this = this;
import React, { useState, Fragment } from 'react';
import Grid from '../Grid';
import Row from '../Row';
import Column from '../Column';
import Text from '../Text';
import Logo from './Logo';
import { ArrowLeft as IconMenuBack, ArrowUp as IconChevronUp, ArrowDown as IconChevronDown, Close as IconMenuClose } from '@dls/assets/icons';
import { withTheme } from '../../core/ThemeProvider';
import styled, { css } from 'styled-components';
import { remCalc } from '@lux/helpers';
import { noop } from '../../helpers';
import Search from './Search';
import Spacing from '../Spacing';
var SCHamburgerMenu = withTheme(styled.div.withConfig({
  displayName: "MobileMenu__SCHamburgerMenu",
  componentId: "sc-yoy9lf-0"
})(function (props) {
  return css(["height:100vh;position:fixed;top:0;left:0;right:0;background-color:", ";border-top:", ";opacity:0;overflow-y:auto;visibility:hidden;z-index:99999;transition:all 400ms ease-out;", " ", ";"], props.backgroundColor, props.coreTheme.header.borderTop, !props.showHamburgerRight && css(["transform:translate(-200px,0);"]), props.isHamburgerMenuOpen && css(["transform:translate(0,0);opacity:1;visibility:visible;"]));
}));
var SCHamburgerGrid = styled(Grid).withConfig({
  displayName: "MobileMenu__SCHamburgerGrid",
  componentId: "sc-yoy9lf-1"
})(["padding-top:0;"]);
var SCHamburgerHeader = withTheme(styled(Row).withConfig({
  displayName: "MobileMenu__SCHamburgerHeader",
  componentId: "sc-yoy9lf-2"
})(function (props) {
  return css(["height:", ";align-items:center;"], props.coreTheme.header.mobileHeight);
}));
var SCSearchInputSpacing = styled(Spacing).withConfig({
  displayName: "MobileMenu__SCSearchInputSpacing",
  componentId: "sc-yoy9lf-3"
})(["width:100%;"]);
var SCIconMenuBack = styled(IconMenuBack).withConfig({
  displayName: "MobileMenu__SCIconMenuBack",
  componentId: "sc-yoy9lf-4"
})(["cursor:pointer;"]);
var SCLogoColumn = styled(Column).withConfig({
  displayName: "MobileMenu__SCLogoColumn",
  componentId: "sc-yoy9lf-5"
})(["display:flex !important;align-items:center !important;"]);
var SCMenuCloseAnchor = styled(Text).withConfig({
  displayName: "MobileMenu__SCMenuCloseAnchor",
  componentId: "sc-yoy9lf-6"
})(["display:block;height:", ";width:", ";float:right;"], remCalc(22), remCalc(22));
var SCMenuCloseIcon = styled.img.withConfig({
  displayName: "MobileMenu__SCMenuCloseIcon",
  componentId: "sc-yoy9lf-7"
})(["height:100%;width:100%;"]);
var SCMenuTextAnchor = withTheme(styled(Text).withConfig({
  displayName: "MobileMenu__SCMenuTextAnchor",
  componentId: "sc-yoy9lf-8"
})(function (props) {
  return css(["display:block;color:", ";font-size:", ";font-family:", ";& svg{float:right;}"], props.active ? props.coreTheme.header.mobileMenuActiveFontColor : props.coreTheme.header.mobileMenuFontColor, props.coreTheme.header.mobileMenuFontSize, props.secondary ? props.coreTheme.ff_sec_thin : props.coreTheme.ff_sec_bold);
}));
var Divider = withTheme(styled.div.withConfig({
  displayName: "MobileMenu__Divider",
  componentId: "sc-yoy9lf-9"
})(function (props) {
  return css(["margin:", " ", ";border-bottom:1px solid ", ";"], remCalc(16), remCalc(-16), props.coreTheme.cl_ter_l5);
}));
var SCColumnPrimaryMenuItem = styled(Column).withConfig({
  displayName: "MobileMenu__SCColumnPrimaryMenuItem",
  componentId: "sc-yoy9lf-10"
})(["padding:0 ", ";"], remCalc(8));
var SCColumnSubMenuItem = styled(SCColumnPrimaryMenuItem).withConfig({
  displayName: "MobileMenu__SCColumnSubMenuItem",
  componentId: "sc-yoy9lf-11"
})(["padding-left:", ";"], remCalc(8));
var SCColumnSubSubMenuItem = styled(Column).withConfig({
  displayName: "MobileMenu__SCColumnSubSubMenuItem",
  componentId: "sc-yoy9lf-12"
})(["padding-left:", ";padding-bottom:0;"], remCalc(32));
var StyledFourthLevelMenuColumn = styled(Column).withConfig({
  displayName: "MobileMenu__StyledFourthLevelMenuColumn",
  componentId: "sc-yoy9lf-13"
})(["padding-left:", ";padding-top:0;padding-bottom:0;"], remCalc(32));
var SCMenuIconChevronUp = styled(IconChevronUp).withConfig({
  displayName: "MobileMenu__SCMenuIconChevronUp",
  componentId: "sc-yoy9lf-14"
})(["cursor:pointer;"]);
var SCMenuIconChevronDown = styled(IconChevronDown).withConfig({
  displayName: "MobileMenu__SCMenuIconChevronDown",
  componentId: "sc-yoy9lf-15"
})(["cursor:pointer;"]);
var SCMenuIconClose = styled(IconMenuClose).withConfig({
  displayName: "MobileMenu__SCMenuIconClose",
  componentId: "sc-yoy9lf-16"
})(["cursor:pointer;"]);
var NestedMenu = function NestedMenu(_ref) {
  var baseUrl = _ref.baseUrl,
    activeSubMenuItem = _ref.activeSubMenuItem,
    activeMenuItem = _ref.activeMenuItem,
    firstLevelLinks = _ref.firstLevelLinks,
    menuItems = _ref.menuItems,
    onAccordionHeaderClick = _ref.onAccordionHeaderClick,
    isFourthLevelMenuOpen = _ref.isFourthLevelMenuOpen,
    onThirdLevelMenuClick = _ref.onThirdLevelMenuClick,
    onMenuItemClick = _ref.onMenuItemClick;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    thirdLevelMenu = _useState2[0],
    setThirdLevelMenu = _useState2[1];
  var onThirdLevelMenuClickCallback = function onThirdLevelMenuClickCallback(menu) {
    setThirdLevelMenu(menu);
    onThirdLevelMenuClick();
  };
  return isFourthLevelMenuOpen ? /*#__PURE__*/React.createElement(Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 167,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
    type: "link",
    href: "".concat(baseUrl).concat(thirdLevelMenu.item.href),
    style: {
      paddingLeft: '8px'
    },
    "data-testid": "fourth-level-menu",
    onClick: function onClick(e) {
      onMenuItemClick(e, thirdLevelMenu.item);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 168,
      columnNumber: 7
    }
  }, thirdLevelMenu.item.title), /*#__PURE__*/React.createElement(Divider, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 7
    }
  }), thirdLevelMenu.subMenu && thirdLevelMenu.subMenu.map(function (menuItem, menuKey) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: menuKey,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 182,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Row, {
      key: menuKey,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(StyledFourthLevelMenuColumn, {
      xs: 12,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 184,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
      type: "link",
      href: "".concat(baseUrl).concat(menuItem.item.href),
      secondary: true,
      onClick: function onClick(e) {
        onMenuItemClick(e, menuItem.item);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 185,
        columnNumber: 17
      }
    }, menuItem.item.title))), /*#__PURE__*/React.createElement(Divider, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 197,
        columnNumber: 13
      }
    }));
  })) : firstLevelLinks.map(function (menuItem, menuKey) {
    return /*#__PURE__*/React.createElement(Row, {
      key: menuKey,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 204,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(SCColumnPrimaryMenuItem, {
      xs: 12,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 206,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
      type: "link",
      href: "".concat(baseUrl).concat(menuItem.href),
      onClick: function onClick(e) {
        onMenuItemClick(e, menuItem);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 207,
        columnNumber: 13
      }
    }, menuItem.title), /*#__PURE__*/React.createElement(Divider, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 217,
        columnNumber: 13
      }
    })), menuItem.active && menuItems && menuItems.map(function (subMenuItem, subKey) {
      return /*#__PURE__*/React.createElement(Column, {
        key: subKey,
        xs: 12,
        style: {
          padding: '0 auto'
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 224,
          columnNumber: 17
        }
      }, /*#__PURE__*/React.createElement(SCColumnSubMenuItem, {
        xs: 12,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 225,
          columnNumber: 19
        }
      }, (subMenuItem.subMenu || []).length > 0 && /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
        type: "link",
        active: subKey === activeSubMenuItem,
        onClick: function onClick() {
          return onAccordionHeaderClick(menuKey, subKey);
        },
        secondary: true,
        "data-testid": "second-level-menu-".concat(subKey + 1),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 228,
          columnNumber: 23
        }
      }, subMenuItem.item.title, subKey === activeSubMenuItem && /*#__PURE__*/React.createElement(SCMenuIconChevronUp, {
        size: 20,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 237,
          columnNumber: 27
        }
      }), subKey !== activeSubMenuItem && /*#__PURE__*/React.createElement(SCMenuIconChevronDown, {
        size: 20,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 240,
          columnNumber: 27
        }
      })), (subMenuItem.subMenu || []).length === 0 && /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
        type: "link",
        href: "".concat(baseUrl).concat(subMenuItem.item.href),
        secondary: true,
        onClick: function onClick(e) {
          onMenuItemClick(e, subMenuItem.item);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 246,
          columnNumber: 23
        }
      }, subMenuItem.item.title)), menuKey === activeMenuItem && subKey === activeSubMenuItem && subMenuItem.subMenu.filter(function (_ref2) {
        var subMenu = _ref2.subMenu;
        return subMenu;
      }) // Filtering away empty subMenu
      .map(function (subSubMenuItem, subSubKey) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: subSubKey,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 265,
            columnNumber: 27
          }
        }, subSubMenuItem.subMenu.length > 0 && /*#__PURE__*/React.createElement(SCColumnSubSubMenuItem, {
          xs: 12,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 268,
            columnNumber: 31
          }
        }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
          type: "link",
          onClick: function onClick(e) {
            onThirdLevelMenuClickCallback(subSubMenuItem);
            onMenuItemClick(e, subSubMenuItem.item);
          },
          secondary: true,
          "data-testid": "third-level-menu-".concat(subSubKey + 1),
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 269,
            columnNumber: 33
          }
        }, subSubMenuItem.item.title)), (subSubMenuItem.subMenu || []).length === 0 && /*#__PURE__*/React.createElement(SCColumnSubSubMenuItem, {
          sm: 12,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 288,
            columnNumber: 31
          }
        }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
          type: "link",
          href: "".concat(baseUrl).concat(subSubMenuItem.item.href),
          secondary: true,
          onClick: function onClick(e) {
            onMenuItemClick(e, subSubMenuItem.item);
          },
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 289,
            columnNumber: 33
          }
        }, subSubMenuItem.item.title)));
      }), /*#__PURE__*/React.createElement(Divider, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 304,
          columnNumber: 19
        }
      }));
    }));
  });
};
var SimpleMenu = function SimpleMenu(_ref3) {
  var baseUrl = _ref3.baseUrl,
    menuItems = _ref3.menuItems,
    onMenuItemClick = _ref3.onMenuItemClick;
  return menuItems.map(function (menuItem, key) {
    return /*#__PURE__*/React.createElement(Row, {
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 316,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(SCColumnPrimaryMenuItem, {
      xs: 12,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 318,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
      type: "link",
      href: "".concat(baseUrl).concat(menuItem.item.href),
      active: menuItem.item.active,
      style: {
        padding: '15px 0px 20px 19px'
      },
      onClick: function onClick(e) {
        onMenuItemClick(e, menuItem.item);
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 319,
        columnNumber: 9
      }
    }, menuItem.item.title)), menuItem.subMenu && menuItem.subMenu.map(function (subMenuItem, subKey) {
      return /*#__PURE__*/React.createElement(Column, {
        key: subKey,
        xs: 12,
        style: {
          padding: '0 auto'
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 335,
          columnNumber: 13
        }
      }, /*#__PURE__*/React.createElement(SCColumnSubMenuItem, {
        style: {
          paddingLeft: '46px',
          paddingBottom: '15px'
        },
        xs: 12,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 336,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(SCMenuTextAnchor, {
        type: "link",
        href: "".concat(baseUrl).concat(subMenuItem.item.href),
        secondary: true,
        onClick: function onClick(e) {
          onMenuItemClick(e, subMenuItem.item);
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 340,
          columnNumber: 17
        }
      }, subMenuItem.item.title)));
    }));
  });
};
var MobileMenu = function MobileMenu(_ref4) {
  var baseUrl = _ref4.baseUrl,
    backgroundColor = _ref4.backgroundColor,
    activeSubMenuItem = _ref4.activeSubMenuItem,
    activeMenuItem = _ref4.activeMenuItem,
    firstLevelLinks = _ref4.firstLevelLinks,
    isHamburgerMenuOpen = _ref4.isHamburgerMenuOpen,
    logo = _ref4.logo,
    menuItems = _ref4.menuItems,
    onClose = _ref4.onClose,
    onAccordionHeaderClick = _ref4.onAccordionHeaderClick,
    showLogoHamburger = _ref4.showLogoHamburger,
    showHamburgerRight = _ref4.showHamburgerRight,
    HamburgerCloseIcon = _ref4.hamburgerCloseIcon,
    _ref4$onMenuItemClick = _ref4.onMenuItemClick,
    onMenuItemClick = _ref4$onMenuItemClick === void 0 ? noop : _ref4$onMenuItemClick,
    searchConfigOptions = _ref4.searchConfigOptions;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFourthLevelMenuOpen = _useState4[0],
    setIsFourthLevelMenuOpen = _useState4[1];
  var closeFourthLevelMenu = function closeFourthLevelMenu() {
    return setIsFourthLevelMenuOpen(false);
  };
  var onCloseMenu = function onCloseMenu() {
    closeFourthLevelMenu();
    onClose();
  };
  var onThirdLevelMenuClick = function onThirdLevelMenuClick() {
    setIsFourthLevelMenuOpen(true);
  };
  return /*#__PURE__*/React.createElement(SCHamburgerMenu, {
    isHamburgerMenuOpen: isHamburgerMenuOpen,
    showHamburgerRight: showHamburgerRight,
    backgroundColor: backgroundColor,
    "data-testid": "mobile-menu",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 389,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SCHamburgerGrid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 395,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(SCHamburgerHeader, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 397,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 398,
      columnNumber: 11
    }
  }, isFourthLevelMenuOpen && /*#__PURE__*/React.createElement(SCIconMenuBack, {
    size: 20,
    onClick: closeFourthLevelMenu,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 400,
      columnNumber: 15
    }
  })), showLogoHamburger && logo && /*#__PURE__*/React.createElement(SCLogoColumn, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 405,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Logo, {
    baseUrl: baseUrl,
    href: logo.href,
    alt: logo.alt,
    src: logo.src,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 406,
      columnNumber: 15
    }
  })), /*#__PURE__*/React.createElement(Column, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 415,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SCMenuCloseAnchor, {
    type: "link",
    onClick: onCloseMenu,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 416,
      columnNumber: 13
    }
  }, HamburgerCloseIcon ? typeof HamburgerCloseIcon === 'string' ? /*#__PURE__*/React.createElement(SCMenuCloseIcon, {
    src: HamburgerCloseIcon,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 419,
      columnNumber: 19
    }
  }) : /*#__PURE__*/React.createElement(HamburgerCloseIcon, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 421,
      columnNumber: 19
    }
  }) : /*#__PURE__*/React.createElement(SCMenuIconClose, {
    size: 22,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 424,
      columnNumber: 17
    }
  })))), searchConfigOptions.showSearch && /*#__PURE__*/React.createElement(Row, {
    "data-testid": "mobile-search-menu-item",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 431,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(SCSearchInputSpacing, {
    top: 1,
    bottom: 2,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 432,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Search, _extends({}, searchConfigOptions, {
    isActive: isHamburgerMenuOpen,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 433,
      columnNumber: 15
    }
  })))), /*#__PURE__*/React.createElement(Row, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 437,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Column, {
    noGutter: true,
    sm: 12,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 438,
      columnNumber: 11
    }
  }, firstLevelLinks && /*#__PURE__*/React.createElement(NestedMenu, {
    baseUrl: baseUrl,
    activeSubMenuItem: activeSubMenuItem,
    activeMenuItem: activeMenuItem,
    firstLevelLinks: firstLevelLinks,
    menuItems: menuItems,
    onAccordionHeaderClick: onAccordionHeaderClick,
    isFourthLevelMenuOpen: isFourthLevelMenuOpen,
    onThirdLevelMenuClick: onThirdLevelMenuClick,
    onMenuItemClick: onMenuItemClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 441,
      columnNumber: 15
    }
  }), !firstLevelLinks && /*#__PURE__*/React.createElement(SimpleMenu, {
    baseUrl: baseUrl,
    menuItems: menuItems,
    onMenuItemClick: onMenuItemClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 454,
      columnNumber: 15
    }
  })))));
};
export default MobileMenu;